import { RootState } from '@/app/types';

export const selectCurrentLanguage = (state: RootState) => state.language.currentLanguage;
export const selectAvailableLanguages = (state: RootState) => state.language.availableLanguages;
export const selectLayoutType = (state: RootState) => state.language.layoutType;
